import { composeRefs as e } from "@radix-ui/react-compose-refs";
import * as t from "react";
import r from "@babel/runtime/helpers/esm/extends";
export const Slot = /*#__PURE__*/t.forwardRef((e, o) => {
  const {
    children: a,
    ...s
  } = e;
  return t.Children.toArray(a).some(l) ? /*#__PURE__*/t.createElement(t.Fragment, null, t.Children.map(a, e => l(e) ? /*#__PURE__*/t.createElement(n, r({}, s, {
    ref: o
  }), e.props.children) : e)) : /*#__PURE__*/t.createElement(n, r({}, s, {
    ref: o
  }), a);
});
Slot.displayName = "Slot";
const n = /*#__PURE__*/t.forwardRef((r, n) => {
  const {
    children: l,
    ...a
  } = r; /*#__PURE__*/
  return t.isValidElement(l) ? /*#__PURE__*/t.cloneElement(l, {
    ...o(a, l.props),
    ref: e(n, l.ref)
  }) : t.Children.count(l) > 1 ? t.Children.only(null) : null;
});
n.displayName = "SlotClone";
export const Slottable = _ref => {
  let {
    children: e
  } = _ref;
  return /*#__PURE__*/t.createElement(t.Fragment, null, e);
};
function l(e) {
  /*#__PURE__*/return t.isValidElement(e) && e.type === Slottable;
}
function o(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const l = e[n],
      o = t[n];
    /^on[A-Z]/.test(n) ? r[n] = function () {
      null == o || o(...arguments), null == l || l(...arguments);
    } : "style" === n ? r[n] = {
      ...l,
      ...o
    } : "className" === n && (r[n] = [l, o].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
export const Root = Slot;